import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { MatchingsTable } from '../../features/matchings'
import { Title } from '../../components/common/Title'

export const Table = (props: RouteProps) => {
  return (
    <>
      <Title color={props.color} title={props.title || ''} />
      <MatchingsTable />
    </>
  )
}
